import { render, staticRenderFns } from "./LicenseConfigure.vue?vue&type=template&id=8df128aa"
import script from "./LicenseConfigure.vue?vue&type=script&lang=js"
export * from "./LicenseConfigure.vue?vue&type=script&lang=js"
import style0 from "./LicenseConfigure.vue?vue&type=style&index=0&id=8df128aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports